import React from 'react';
import styled from 'styled-components';
import SecondaryHeading from '../Heading/SecondaryHeading';
import SubTitle from '../Heading/SubTitle';
import { useHistory } from 'react-router';

const PropertyPopup = ( { popupHandler, data, saveEditData }: any ) => {

   
    return (
        <PropertyPopupWrapper>
            <div className="close-area">
                <button onClick = { popupHandler } ><span>X</span></button>  
            </div>
            <div className = 'property-container' >
                <div className="property-title">
                    <SecondaryHeading text = { data?.propertyName + ' |' } />
                    {/* <button onClick = { async ( ) => { 
                        console.log( 'confosle ', data );
                        saveEditData( data );
                        // await saveEditData( data );
                        // routerHistory.push('/add-plots?edit=true');
                    } } >Edit</button> */}
                    {/* <Link to = '/add-plots?edit=true'>Edit</Link> */}
                </div>
                <div className="property-basic-info">
                    <div className="property-type">Type: <span>{ data?.type }</span></div>
                    <div className="property-type">SubType: <span>{ data?.subType }</span></div>
                </div>
                <div className="property-description property-sec">
                    <SubTitle text = { "description" } />
                    <ul className = 'show-list'>
                    {
                        data.description ?
                        data.description.map( ( item: any ) => <li key = { item } className = 'list'>{ item }</li> )
                        :
                        ''
                    }
                    </ul>
                </div>
                <div className="property-amenities property-sec">
                    <SubTitle text = { "Amenities" } />
                    <ul className = 'show-list'>
                    {
                        data.amenties ?
                        data.amenties.map( ( item: any ) => <li key = { item } className = 'list'>{ item }</li> )
                        :
                        ''
                    }
                    </ul>
                </div>
                <div className="property-images property-sec">
                    <SubTitle text = { "images" } />
                    {/* data.imageLink.map */}
                    {
                        data?.imageLink.map( ( item: any ) => { 
                            return (
                                <img key = { item } src = { item } alt="Plot area" width = '500' height = '200' />
                            )
                        } )
                    }
                    <img src = '' width = "200" height = "200" alt = "Plot Area" />
                </div>
                <div className="property-video property-sec">
                    <SubTitle text = { "site video" } />
                    {
                        data?.videoLink.map( ( item: any ) => {
                            return (
                                <iframe key = { item } width="560" height="315" src={ item } title="YouTube video player" frameBorder={ 0 } allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>                
                            )
                        } )
                    }
                </div>
                <div className="property-address property-sec">
                    <SubTitle text = { "property address" } />
                    {/* <h3> { props.data?.address }</h3> */}
                    {/* <h3>Nearby Location: { props.data?.nearbyLocation }</h3> */}
                    <div className="property-address-info">
                        <div className="property-address">Address: <span>{ data?.address }</span></div>
                        <div className="property-address">Nearby Location: <span>{ data?.nearbyLocation }</span>
                    </div>
                </div>
                    <iframe title="Map"src={ data?.addressMapLink } width="400" height="300" style={{ border: 0 }} loading="lazy"></iframe>
                </div>
            </div>               
        </PropertyPopupWrapper>
    )
}



// export default connect( null,  

//     saveEditData

// ) ( PropertyPopup );

export default PropertyPopup;


const PropertyPopupWrapper = styled.div`

    width: 70vw;
    height: 80vh;
    overflow-y: scroll;
    border: 1px solid black;
    opacity: 1;
    background: #fdd996;
    display: flex;
    flex-direction: column;
    align-items: center;

    .property-title {
        display: flex;
        justify-content: center;
        margin-top: 2rem;
        margin-bottom: 1rem;
        button {

            background: transparent;
            border: 1px solid black;
            outline: none;
            color: #0e2e04;
            border-radius: 5px;
            padding: 2px 15px;
            font-size: 25px;
            font-weight: bolder;
            letter-spacing: 2px;
        }
    }

    ::-webkit-scrollbar {
        width: 5px;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.9); 
        border-radius: 1px;
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 3px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.7); 
    }
    
    .close-area {
        width: 100%;
        background: #bde5ec;
        button {
            float: right;
            clear: both;
            background: transparent;
            padding: 8px;
            font-size: 18px;
            color: #000000;
            font-weight: bolder;
            border: none;
            outline: none;
            /* margin-right: 20px; */
            background: #db0000;
        }
    }
    .property-basic-info {
        display: flex;
        justify-content: space-around;
        margin: 0 auto;
            .property-type {
            font-size: 20px;
            font-weight: bolder;
            margin: 20px;
            letter-spacing: 2px;

        }
        span {
            font-size: 18px;
            padding: 10px;
            text-decoration: underline;
            font-style: italic;
        }
    }

    .property-sec {
        margin: 20px;
        padding-top: 2rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .list {
        padding: 10px;
        list-style: circle;
        font-size: 18px;
        letter-spacing: 2px;
        text-transform: capitalize;
    }

    .property-address-info {

        margin: 20px auto;
        font-size: 20px;
        border: 5px solid black;
        width: 70%;
        overflow-wrap: break-word;
        letter-spacing: 2px;
        background: wheat;
        padding: 20px;

        .property-address {
            font-weight: bolder;
            margin: 10px;
        }
        span {

            font-weight: lighter;
            font-style: italic;
            text-decoration: underline;
        }
    }

    image, iframe {
        margin: 20px;

    }

`; 

